import extend from './extend/index'

const config = {
  auth: {
    //Register
    registerIsEnabled: false,
    //Login
    forgotPasswordIsEnabled: true
  },
  files: {
    staticServer: 'static.baarbaanet.com',
    prefixUrl: false, // set false to disable
    thumbServer: 'img.baarbaanet.com/unsafe', // set false to disable
    noImageUrl: '/img/base/no-image.svg',
    imagePlaceholderUrl: '/img/base/empty.svg',
    imageErrorUrl: '/img/base/image-error.svg',
    watermarkUrl: false // set false to disable
  },
  apiServer: 'api.baarbaanet.com',
  apiServerPrefix: 'v1',
  ssl: true,
  websiteUrl: 'https://baarbaanet.com',
  firebase: {
    config: {
      apiKey: 'AIzaSyBXh8ZUpPsSWsUHrS0faYXoRcN3vFbiWP8',
      authDomain: 'baarbaanet-3d3d3.firebaseapp.com',
      projectId: 'baarbaanet-3d3d3',
      storageBucket: 'baarbaanet-3d3d3.appspot.com',
      messagingSenderId: '1064221891381',
      appId: '1:1064221891381:web:872205b8515cd597038a7c',
      measurementId: 'G-VKV8CSV3FJ'
    },
    vapidKey:
      'BHojKQlR3PHP8KuE0oIJxI4QMpxHKO5sHIOHBwaJG4UFOfvnxNx-ly8kqgt_rzk3SPKhOpPwJzjKzAql3r4csOs'
  },
  sentry: false
}

export default extend(config)
